import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Goal } from '@models/performance/goal.model';

@Component({
    selector: 'app-form-goal-metrics',
    templateUrl: './goal-metrics.template.html',
})
export class GoalMetricsForm extends BaseForm {
    @Input() goal: Goal;

    /**
     * Static Children Item Edit Mode
     */
    milestoneEditMode = false;

    /**
     * Add a custom field
     */
    addMilestone(): void {
        this.goal.metricMilestones = this.goal.metricMilestones || [];
        this.goal.metricMilestones.push({
            label: null,
            description: null,
            editMode: true,
        });

        this.milestoneEditMode = true;
    }

    /**
     * Remove a custom field by index
     */
    removeMilestone(index: number): void {
        this.goal.metricMilestones.splice(index, 1);
        this.milestoneEditMode = false;
    }

    validMilestones(): boolean {
        return !!(
            (this.goal.metricType === 'milestones' &&
                this.goal.metricMilestones &&
                this.goal.metricMilestones.length) ||
            this.goal.metricType !== 'milestones'
        );
    }

    metricTypeChange(val: any): void {
        this.goal.metricMilestones = null;
        if (val === 'percent') {
            this.goal.metricValue = 100;
        } else if (val === 'binary') {
            this.goal.metricValue = 1;
        } else if (val === 'number') {
            this.goal.metricValue = null;
        } else if (val === 'milestones') {
            this.goal.metricValue = 100;
            this.goal.metricMilestones = [];
        } else if (val === 'dollar') {
            this.goal.metricValue = val;
        }
    }
}
